import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';
import styles from '../styles';

const CircleButton = ({ onPress, customStyle, iconName }: any) => {
  return (
    <TouchableOpacity style={customStyle} onPress={onPress}>
      <View style={styles.circleClose}>
        <Icon
          color="#5d5d5d"
          name={iconName || 'close'}
          size={20}
          tvParallaxProperties={null}
        />
      </View>
    </TouchableOpacity>
  );
};

export default CircleButton;
